import dayjs, { type Dayjs } from 'dayjs';

/** ISO strings with the local offset, from the machine's clock. */
export interface DayWindow {
  start: string;
  end: string;
}

/** Milliseconds kept, so the end bound is the day's last instant and not a second early. */
const ISO_WITH_OFFSET = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

export function todayWindow(now: Dayjs = dayjs()): DayWindow {
  return { start: now.startOf('day').format(ISO_WITH_OFFSET), end: now.endOf('day').format(ISO_WITH_OFFSET) };
}

/** Adds a second of slack so the new day has started when a timer fires. */
export function msUntilNextDay(now: Dayjs = dayjs()): number {
  return now.endOf('day').diff(now) + 1000;
}
